export default "__VITE_ASSET__555c0b75__"